import { DomPainter } from "@evergis/sgis/es/painters/DomPainter/DomPainter";

import { map } from "./map";

export const painter = new DomPainter(map);
